"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const account_1 = require("../../account");
const js_getTransactionStatus_1 = __importDefault(require("./js-getTransactionStatus"));
const js_prepareTransaction_1 = __importDefault(require("./js-prepareTransaction"));
const js_createTransaction_1 = __importDefault(require("./js-createTransaction"));
const estimateMaxSpendable = ({ account, parentAccount, transaction, }) => __awaiter(void 0, void 0, void 0, function* () {
    const mainAccount = (0, account_1.getMainAccount)(account, parentAccount);
    const t = yield (0, js_prepareTransaction_1.default)(mainAccount, Object.assign(Object.assign(Object.assign({}, (0, js_createTransaction_1.default)()), transaction), { useAllAmount: true }));
    const s = yield (0, js_getTransactionStatus_1.default)(mainAccount, t);
    return s.amount;
});
exports.default = estimateMaxSpendable;
//# sourceMappingURL=js-estimateMaxSpendable.js.map